import { memo } from "react";

import { QuestionKeyVisuals } from "@/components/features/items/edit/_shared/ui/components/main/questions/key-visual/key-visuals/key-visuals";
import { QuestionMainKeyVisual } from "@/components/features/items/edit/_shared/ui/components/main/questions/key-visual/main-key-visual/index";

import { useRoomKeyVisual } from "./use-key-visual/use-key-visual";

type Props = {
	ownerID: string;
	resourceID: string;
};

export const QuestionRoomKeyVisual = memo(({ ownerID, resourceID }: Props) => {
	const { keyVisuals, mainKeyVisual, errorMessageMainKV, onSetKeyVisuals, onSetMainKeyVisual } = useRoomKeyVisual();

	return (
		<div className="space-y-8">
			<QuestionMainKeyVisual
				ownerID={ownerID}
				resourceID={resourceID}
				mainKeyVisual={mainKeyVisual}
				onSetMainKeyVisual={onSetMainKeyVisual}
				errorMessage={errorMessageMainKV}
				isEdited={false}
			/>
			<QuestionKeyVisuals
				ownerID={ownerID}
				resourceID={resourceID}
				KVsErrorMessage={undefined}
				onSetKeyVisuals={onSetKeyVisuals}
				keyVisuals={keyVisuals}
			/>
		</div>
	);
});

QuestionRoomKeyVisual.displayName = "QuestionRoomKeyVisual";
